import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { TEXT_ALIGNMENT_OPTIONS, TextAlignmentOptions, Icon } from '#const';
import { getIconUrl } from '#utils';

const TrapezoidHero = dynamic(() => import('./TrapezoidHero'));

Builder.registerComponent(TrapezoidHero, {
	name: 'TrapezoidHero',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Desktop Heading',
			type: 'richText',
			required: true,
			defaultValue: '<h1>ATTENTION</h1>',
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional text alignment for the heading.',
		},
		{
			name: 'copy',
			friendlyName: 'Desktop Text',
			type: 'richText',
			required: true,
			defaultValue:
				'<p>Every day, corporations sell harmful products known to cause cancer and other illnesses. If you are seriously ill or injured, you may qualify for significant compensation.</p>',
		},
		{
			name: 'copyAlignment',
			friendlyName: 'Text Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
			helperText: 'Optional text alignment for the body text.',
		},
		{
			name: 'backgroundImage',
			friendlyName: 'Background Image Information',
			type: 'object',
			subFields: [
				{
					name: 'src',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
				},
				{
					name: 'alt',
					friendlyName: 'Alt Text',
					type: 'string',
				},
			],
		},
		{
			name: 'textBackgroundColor',
			friendlyName: 'Text Background Color',
			type: 'color',
			defaultValue: '#808080',
		},
		{
			name: 'topTrapezoidWidth',
			friendlyName: 'Top Width (%)',
			type: 'number',
			defaultValue: 70,
			min: 0,
			max: 100,
		},
		{
			name: 'bottomTrapezoidWidth',
			friendlyName: 'Bottom Width (%)',
			type: 'number',
			defaultValue: 50,
			min: 0,
			max: 100,
		},
		{
			name: 'topTrapezoidWidthMobile',
			friendlyName: 'Mobile Top Width (%)',
			type: 'number',
			defaultValue: 90,
			min: 0,
			max: 100,
		},
		{
			name: 'bottomTrapezoidWidthMobile',
			friendlyName: 'Mobile Bottom Width (%)',
			type: 'number',
			defaultValue: 60,
			min: 0,
			max: 100,
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'See if I Qualify',
					arrow: true,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.HERO),
});
